export const getMadeiraData = () => ({
  name: "Madeira",
  country: "Portugal",
  description: "L'île de Madère est célèbre pour ses vins fortifiés uniques, vieillis en fûts sous l'effet de la chaleur et de l'humidité.",
  type: "region",
  subregions: [
    { name: "Câmara de Lobos", area: "500 ha", percentage: "25%", description: "Berceau du vin de Madère" },
    { name: "Funchal", area: "500 ha", percentage: "25%", description: "Capitale de l'île" },
    { name: "Porto Moniz", area: "500 ha", percentage: "25%", description: "Vins de montagne" },
    { name: "Santana", area: "500 ha", percentage: "25%", description: "Vins du nord-est" }
  ],
  mapAreas: [
    { region: "Câmara de Lobos", x: 82, y: 82, color: "#4B164C", size: 1 },
    { region: "Funchal", x: 84, y: 84, color: "#6d2c7a", size: 1 },
    { region: "Porto Moniz", x: 86, y: 86, color: "#8a4a8a", size: 1 },
    { region: "Santana", x: 88, y: 88, color: "#a768a6", size: 1 }
  ],
  statistics: {
    totalArea: "2,000 ha",
    production: "40,000 hl",
    wineries: "10+ domaines",
    appellations: "4 sous-régions",
    exportPercentage: "90% (vin de Madère)"
  },
  characteristics: {
    climate: "Climat subtropical, humidité élevée, températures douces",
    soil: "Sols volcaniques, terrasses escarpées",
    viticulture: "Vendanges manuelles, cépages Malvasia, Sercial, Bual, Verdelho"
  },
  wineStyles: {
    fortified: "Vins de Madère : du sec (Sercial) au doux (Malvasia), grande longévité"
  },
  history: "Le vin de Madère était exporté dès le XVe siècle. Son vieillissement unique (chauffe) lui confère une longévité exceptionnelle.",
  foodPairing: "Pâtisseries, fromages, plats sucrés-salés, apéritif ou dessert"
}); 